import { render, staticRenderFns } from "./BMenu.vue?vue&type=template&id=ac22103c&scoped=true"
import script from "./BMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./BMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BMenu.vue?vue&type=style&index=0&id=ac22103c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac22103c",
  null
  
)

export default component.exports